import {Component, Input, OnInit} from '@angular/core';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {Router} from '@angular/router';
import Swal, {default as swal} from 'sweetalert2';
import {ChecklistModel} from '../../../shared/dto/checklist.model';
import {ApprovalService} from '../../../service/approval.service';
import {FormControl, FormGroup} from '@angular/forms';
import {ReversedBlacklistService} from '../../../shared/service/reversed-blacklist.service';
import {ReversedSuspendService} from '../../../shared/service/reversed-suspend.service';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {ReversedSuspendBlacklistService} from '../../../shared/service/reversed-suspend-blacklist.service';

@Component({
  selector: 'app-reversed-remarks',
  templateUrl: './reversed-remarks.component.html',
  styleUrls: ['./reversed-remarks.component.scss']
})
export class ReversedRemarksComponent implements OnInit {


  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  public checklist: ChecklistModel[];
  public isValidChecklist = true;
  public selectedIdArr: number[]=[];
  public checklistId: number[]=[];
  public applicantType : string;

  constructor(private approvalService: ApprovalService, private router: Router,private blacklistService:ReversedBlacklistService,
              private suspendReverseProcess: ReversedSuspendService,
              private reversedSuspendBlacklistService: ReversedSuspendBlacklistService) { }

  ngOnInit() {
    console.log(this.fromParent,"this.fromParent");
    this.approvalModel = this.fromParent.model;
    this.applicantType = this.fromParent.appType;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;
    // alert(this.applicantType);
    if(this.approvalModel.process === ActionMode.BLACKLIST){
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {

        if (result.value) {
          this.blacklistService.approveRequeat(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.router.navigate(['/dashboard/reversed-blacklist', this.applicantType] );
              this.approvalService.close();
            },
            (error) => {
              swal.fire('Error', 'Error When Updating the Request', 'error');
            },
          );
        } else {
        }
      });
    } else if(this.approvalModel.process === ActionMode.SUSPEND) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.suspendReverseProcess.approveRequeat(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");

              if(this.router.url.includes('/dashboard/reversed-suspend-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend', this.applicantType]);

              }
                this.approvalService.close();
            },
            (error) => {
              swal.fire("Sorry!", "Error When Updating the Request...!", "error");
            },
          );
        } else {
        }
      });
    }else if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND_BLACKLIST) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.reversedSuspendBlacklistService.approveRequeat(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
              this.router.navigate(['/dashboard/reversed-suspend-blacklist', this.applicantType]);
              // if(this.router.url.includes('/dashboard/reversed-suspend-blacklist-data/')) {
              //   this.router.navigate(['/dashboard/reversed-suspend-blacklist']);
              //
              // }
              this.approvalService.close();
            },
            (error) => {
              swal.fire("Sorry!", "Error When Updating the Request...!", "error");
            },
          );
        } else {
        }
      });
    }
  }

}
